var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.run
    ? _c("div", { staticClass: "details-page" }, [
        _c("div", { staticClass: "md-layout" }, [
          _c("div", { staticClass: "md-layout-item" }, [
            _c("div", { staticClass: "custom-toolbar" }, [
              _c("div", { staticClass: "custom-toolbar-start" }, [
                _vm.run.runName != null
                  ? _c("h3", { staticClass: "title" }, [
                      _vm._v("Run " + _vm._s(_vm.run.runName)),
                    ])
                  : _vm._e(),
              ]),
              !_vm.$root.isMobileOnly && !_vm.isReadOnlyUser
                ? _c("div", { staticClass: "custom-toolbar-end" }, [
                    _c(
                      "div",
                      { staticClass: "header-button-container" },
                      [
                        _c("run-status-button", {
                          staticClass: "status-btn",
                          attrs: { "class-name": "md-sm", run: _vm.run },
                          on: { statusUpdated: _vm.handleChangedRunStatus },
                        }),
                        _c("run-edit-button", { attrs: { run: _vm.run } }),
                      ],
                      1
                    ),
                  ])
                : _vm._e(),
            ]),
          ]),
        ]),
        _c(
          "div",
          {
            staticClass: "md-layout md-alignment-top-left content-layout-panel",
          },
          [
            _c(
              "div",
              {
                staticClass:
                  "md-layout-item md-small-size-100 md-medium-size-100 md-layout md-large-size-66 md-xlarge-size-50",
              },
              [
                _c(
                  "div",
                  {
                    staticClass:
                      "md-layout-item md-large-size-100 md-medium-size-100 md-small-size-100 md-xlarge-size-100",
                  },
                  [
                    _c(
                      "md-card",
                      [
                        _c(
                          "md-card-header",
                          {
                            staticClass:
                              "md-card-header-icon md-card-header-blue",
                          },
                          [
                            _c(
                              "div",
                              { staticClass: "card-icon" },
                              [_c("md-icon", [_vm._v("description")])],
                              1
                            ),
                          ]
                        ),
                        _c("md-card-content", [
                          _c(
                            "div",
                            { staticClass: "single-row three-column-box" },
                            [
                              _c(
                                "div",
                                { staticClass: "custom-md-field details-box" },
                                [
                                  _c("div", { staticClass: "custom-label" }, [
                                    _vm._v("Assigned To"),
                                  ]),
                                  _vm.run.assignedTo &&
                                  _vm.run.assignedTo.publicUserId
                                    ? _c(
                                        "router-link",
                                        {
                                          attrs: {
                                            to: {
                                              name: "Team Member Profile",
                                              params: {
                                                publicUserId:
                                                  _vm.run.assignedTo
                                                    .publicUserId,
                                              },
                                            },
                                            target: "_blank",
                                          },
                                        },
                                        [
                                          _vm._v(
                                            "\n                                    " +
                                              _vm._s(
                                                _vm.run.assignedTo.fullName ||
                                                  _vm.run.assignedTo
                                                    .publicUserId
                                              ) +
                                              "\n                                "
                                          ),
                                        ]
                                      )
                                    : _c("span", [_vm._v("Unassigned")]),
                                ],
                                1
                              ),
                              _c("div", { staticClass: "details-box" }, [
                                _c("label", [_vm._v("Customer")]),
                                _c("span", { staticClass: "value" }, [
                                  _vm._v(_vm._s(_vm.run.customerName)),
                                ]),
                              ]),
                              _c("div", { staticClass: "details-box" }, [
                                _c("label", [_vm._v("Rate Group")]),
                                _c("span", { staticClass: "value" }, [
                                  _vm._v(_vm._s(_vm.run.rateGroupName)),
                                ]),
                              ]),
                            ]
                          ),
                          _c(
                            "div",
                            { staticClass: "single-row three-column-box" },
                            [
                              _c("div", { staticClass: "details-box" }, [
                                _c("label", [_vm._v("Run Date")]),
                                _c("span", { staticClass: "value" }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm._f("dateFormat")(
                                        _vm.run.runDate,
                                        _vm.DATE_TYPES.standardDate
                                      )
                                    )
                                  ),
                                ]),
                              ]),
                              _c("div", { staticClass: "details-box" }, [
                                _c("label", [_vm._v("Start Time")]),
                                _c("span", { staticClass: "value" }, [
                                  _vm._v(
                                    "\n                                    " +
                                      _vm._s(
                                        _vm._f("dateTimeFormat")(
                                          _vm.run.startTime,
                                          _vm.DATE_TYPES.standardDate
                                        )
                                      ) +
                                      "\n                                "
                                  ),
                                ]),
                              ]),
                              _c("div", { staticClass: "details-box" }, [
                                _c("label", [_vm._v("Completed Time")]),
                                _c("span", { staticClass: "value" }, [
                                  _vm._v(
                                    "\n                                    " +
                                      _vm._s(
                                        _vm._f("dateTimeFormat")(
                                          _vm.run.completedDate,
                                          _vm.DATE_TYPES.standardDate
                                        )
                                      ) +
                                      "\n                                "
                                  ),
                                ]),
                              ]),
                            ]
                          ),
                          _vm.run.customerInvoiceId
                            ? _c("div", { staticClass: "details-box" }, [
                                _c("label", { staticClass: "label" }, [
                                  _vm._v("Customer Invoice:"),
                                ]),
                                _c(
                                  "span",
                                  { staticClass: "value" },
                                  [
                                    _vm.run.customerInvoiceStatus
                                      ? _c(
                                          "div",
                                          {
                                            class:
                                              "custom-badge payment-status-" +
                                              _vm.run.customerInvoiceStatus
                                                .toLowerCase()
                                                .replace(/\s+/g, ""),
                                          },
                                          [
                                            _vm._v(
                                              "\n                                    " +
                                                _vm._s(
                                                  _vm.$t(
                                                    "inputs.paymentStatuses." +
                                                      _vm.run
                                                        .customerInvoiceStatus
                                                  )
                                                ) +
                                                "\n                                "
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                    _c(
                                      "router-link",
                                      {
                                        attrs: {
                                          to: {
                                            name: "Customer Invoice Details",
                                            params: {
                                              invoiceId:
                                                _vm.run.customerInvoiceId,
                                            },
                                          },
                                          target: "_blank",
                                        },
                                      },
                                      [
                                        _vm._v(
                                          "\n                                    " +
                                            _vm._s(
                                              _vm.run.customerInvoiceNumber
                                            ) +
                                            "\n                                "
                                        ),
                                      ]
                                    ),
                                  ],
                                  1
                                ),
                              ])
                            : _vm._e(),
                          _vm.run.teamMemberInvoiceId
                            ? _c("div", { staticClass: "details-box" }, [
                                _c("label", { staticClass: "label" }, [
                                  _vm._v("Team Member Invoice:"),
                                ]),
                                _c(
                                  "span",
                                  { staticClass: "value" },
                                  [
                                    _vm.run.teamMemberInvoiceStatus
                                      ? _c(
                                          "div",
                                          {
                                            class:
                                              "custom-badge payment-status-" +
                                              _vm.run.teamMemberInvoiceStatus
                                                .toLowerCase()
                                                .replace(/\s+/g, ""),
                                          },
                                          [
                                            _vm._v(
                                              "\n                                    " +
                                                _vm._s(
                                                  _vm.$t(
                                                    "inputs.paymentStatuses." +
                                                      _vm.run
                                                        .teamMemberInvoiceStatus
                                                  )
                                                ) +
                                                "\n                                "
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                    _c(
                                      "router-link",
                                      {
                                        attrs: {
                                          to: {
                                            name: "Team Member Invoice Details",
                                            params: {
                                              invoiceId:
                                                _vm.run.teamMemberInvoiceId,
                                            },
                                          },
                                          target: "_blank",
                                        },
                                      },
                                      [
                                        _vm._v(
                                          "\n                                    " +
                                            _vm._s(
                                              _vm.run.teamMemberInvoiceNumber
                                            ) +
                                            "\n                                "
                                        ),
                                      ]
                                    ),
                                  ],
                                  1
                                ),
                              ])
                            : _vm._e(),
                        ]),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "div",
                  {
                    staticClass:
                      "md-layout-item md-small-size-100 md-large-size-100 md-xlarge-size-100",
                  },
                  [
                    _c(
                      "md-card",
                      [
                        _c(
                          "md-card-header",
                          {
                            staticClass:
                              "md-card-header-icon md-card-header-warning",
                          },
                          [
                            _c(
                              "div",
                              { staticClass: "card-icon" },
                              [_c("md-icon", [_vm._v("list")])],
                              1
                            ),
                          ]
                        ),
                        _c(
                          "md-card-content",
                          [
                            !_vm.run.stopList || !_vm.run.stopList.length
                              ? _c(
                                  "p",
                                  { staticClass: "grayedout-text text-center" },
                                  [
                                    _vm._v(
                                      "\n                            No Stops\n                        "
                                    ),
                                  ]
                                )
                              : _c("stop-list-table", {
                                  attrs: { "trip-details": _vm.run },
                                }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "div",
                  {
                    staticClass:
                      "md-layout-item md-small-size-100 md-large-size-100 md-xlarge-size-100",
                  },
                  [
                    _c("run-services", {
                      attrs: {
                        services: _vm.services,
                        "run-id": _vm.run.runId,
                        "is-invoiced": _vm.run.customerInvoiceId !== null,
                      },
                      on: { serviceUpdated: _vm.handleServicesUpdated },
                    }),
                  ],
                  1
                ),
              ]
            ),
            _c(
              "div",
              {
                staticClass:
                  "md-layout-item md-small-size-100 md-layout md-medium-size-100 md-large-size-33 md-xlarge-size-50",
              },
              [
                !_vm.isIndividualUser
                  ? _c(
                      "div",
                      {
                        staticClass:
                          "md-layout-item md-small-size-100 md-large-size-100 md-xlarge-size-100",
                      },
                      [
                        _vm.canAccessRates || _vm.isAdmin || _vm.isReadOnlyUser
                          ? _c("charge-rates-list", {
                              attrs: {
                                "charge-lines": _vm.run.chargeLines,
                                "service-lines": _vm.serviceChargeLines,
                                "has-invoice":
                                  _vm.run.customerInvoiceId !== null,
                                title: "Run Charges",
                                "rates-have-changed":
                                  _vm.updateChargesInBackground,
                                "run-details": _vm.run,
                              },
                              on: { updateRunDetails: _vm.getRunDetails },
                            })
                          : _vm._e(),
                      ],
                      1
                    )
                  : _vm._e(),
                !_vm.isIndividualUser
                  ? _c(
                      "div",
                      {
                        staticClass:
                          "md-layout-item md-small-size-100 md-large-size-100 md-xlarge-size-100",
                      },
                      [
                        _vm.canAccessRates || _vm.isAdmin
                          ? _c("cost-rates-list", {
                              attrs: {
                                "cost-lines": _vm.run.costLines,
                                "service-lines": _vm.serviceCostLines,
                                "has-invoice":
                                  _vm.run.teamMemberInvoiceId !== null,
                                title: "Run Costs",
                                "rates-have-changed":
                                  _vm.updateCostsInBackground,
                                "run-details": _vm.run,
                              },
                              on: { updateRunDetails: _vm.getRunDetails },
                            })
                          : _vm._e(),
                      ],
                      1
                    )
                  : _vm._e(),
              ]
            ),
          ]
        ),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }